/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const canViewCPF = (permission: string): boolean => {
  const usuariosQuePodeVerCPF = [
    'REPRESENTANTE LEGAL MUNICIPAL',
    'REPRESENTANTE LEGAL ESTADUAL',
    'GERENTE MUNICIPAL',
    'GERENTE ESTADUAL',
    'ADMINISTRADOR',
  ];

  return usuariosQuePodeVerCPF.includes(permission);
};

export const verifyUserUUID = (user: any, userUUID: string): boolean => {
  return user.uuid === userUUID;
};
